import { getToApi, patchToApi, postToApi } from './axios';

/**
 * Bandeja de solicitudes de derechos del titular (Ley 21.719, sub-proyecto C).
 *
 * El backend exige rol: pasan ejecutivo, supervisor y liftlogic. El técnico y el
 * administrador de edificio reciben 403 (`code: 'ROLE_FORBIDDEN'`).
 */

const qs = (params) => {
  const sp = new URLSearchParams();
  Object.entries(params || {}).forEach(([k, v]) => {
    if (v !== undefined && v !== null && v !== '') sp.append(k, v);
  });
  const s = sp.toString();
  return s ? `?${s}` : '';
};

export const TIPOS_SOLICITUD = [
  'acceso',
  'rectificacion',
  'supresion',
  'oposicion',
  'portabilidad',
  'bloqueo',
];

export const ESTADOS_SOLICITUD = ['recibida', 'en_revision', 'bloqueada', 'resuelta', 'rechazada'];

export const ESTADOS_CERRADOS = ['resuelta', 'rechazada'];

// Solo acepta estado, tipo, limit y offset. No hay búsqueda ni orden configurable:
// el backend ordena siempre por vence_at ascendente, o sea lo más urgente primero.
export const listDataRequests = (params) => getToApi(`/data-requests${qs(params)}`);

// Devuelve { solicitud, informe }: el informe es la salida del localizador y trae los
// datos personales del titular. No lo dejes en un log ni lo mandes a ningún lado.
export const getDataRequest = (id) => getToApi(`/data-requests/${id}`);

// PATCH: putToApi no propaga method override (ver comentario en api/tickets.js).
// Acepta { estado, resolucion, motivo_rechazo }. Rechazar sin motivo_rechazo da 400.
export const updateDataRequest = (id, body) =>
  patchToApi(`/data-requests/${id}`, body).then((r) => r.data);

// Destructivo e irreversible: no hay vuelta atrás una vez que responde 200.
export const anonimizarDataRequest = (id, body) =>
  postToApi(`/data-requests/${id}/anonimizar`, body ?? {}).then((r) => r.data);

// Reversible: suspende el tratamiento, no borra nada.
export const bloquearDataRequest = (id, body) =>
  postToApi(`/data-requests/${id}/bloquear`, body ?? {}).then((r) => r.data);
